// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1JUZg","overflowing":"ReadFullNote_overflowing__3f_dF"};